// Generated file - do not change manually!

/**
 * Defines the semantic color
 */
export enum SemanticColor {
  /**
   * Critical color
   */
  Critical = 'Critical',

  /**
   * Default color (brand color)
   */
  Default = 'Default',

  /**
   * Negative color
   */
  Negative = 'Negative',

  /**
   * Neutral color.
   */
  Neutral = 'Neutral',

  /**
   * Positive color
   */
  Positive = 'Positive'
}
